import {
  Component,
  ChangeDetectionStrategy,
  OnInit,
  inject,
  signal,
  PLATFORM_ID,
} from '@angular/core';
import { CommonModule, isPlatformBrowser } from '@angular/common';
import { SectionTitleComponent } from '../../shared/components/section-title/section-title.component';
import { FaqAccordionComponent } from '../../shared/components/faq-accordion/faq-accordion.component';
import {
  TestimonialCardComponent,
  TestimonialData,
} from '../../shared/components/testimonial-card/testimonial-card.component';
import { BrokerService } from '../../core/services/core/broker.service';
import { Address, AppMaster, Broker, FAQ } from '../../core/models/api/app-main.model';
import { AppMainService } from '../../core/services/core/app-main.service';

@Component({
  selector: 'app-about',
  standalone: true,
  imports: [CommonModule, SectionTitleComponent, FaqAccordionComponent, TestimonialCardComponent],
  templateUrl: './about.component.html',
  styleUrls: ['./about.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AboutComponent implements OnInit {
  private readonly brokerService = inject(BrokerService);
  private readonly appMainService = inject(AppMainService);
  brokers = signal<Broker[]>([]);
  teamLoading = signal(true);
  faqs: FAQ[] = [];
  mainAddress = signal<Address | null>(null);

  ngOnInit(): void {
    this.loadMasterData();
    this.loadBrokers();
  }

  private loadMasterData() {
    this.appMainService.getMasterConfig().subscribe({
      next: (master: AppMaster) => {
        if (master && master.faqs) {
          this.faqs = master.faqs;
        }
        if (master && master.appMain.mainLocation) {
          this.mainAddress.set(master.appMain.mainLocation?.address || null);
        }
      },
    });
  }

  private loadBrokers(): void {
    this.brokerService.getBrokers().subscribe({
      next: (res) => {
        this.brokers.set(res || []);
        this.teamLoading.set(false);
      },
      error: (err) => {
        console.error('[AboutComponent] Failed to load brokers:', err);
        this.teamLoading.set(false);
      },
    });
  }

  private platformId = inject(PLATFORM_ID);

  openMap(lat: string | null, lng: string | null): void {
    if (!isPlatformBrowser(this.platformId)) return;
    const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !(window as any).MSStream;

    let url: string;
    if (isIOS) {
      // Apple Maps URL: maps://maps.apple.com/?q=...
      url = `maps://maps.apple.com/?q=${lat},${lng}`;
    } else {
      // Google Maps URL: https://www.google.com/maps?q=...
      url = `https://www.google.com/maps?q=${lat},${lng}`;
    }

    window.open(url, '_blank', 'noopener,noreferrer');
  }

  reviews: TestimonialData[] = [
    {
      id: '1',
      name: 'Jennifer Teeter',
      role: 'Seller',
      image: 'assets/images/about/reviews/chloe.jpg',
      text: 'Supportive broker who knew details of contract whenever I called. My location was Puerto Rico, Stephen is based in Texas and made the transaction painless. I love the boat. No problems.',
      rating: 5,
    },
    {
      id: '2',
      name: 'Shawn Watford',
      role: 'Verified Buyer',
      image: 'assets/images/about/reviews/david.jpg',
      text: 'League City Yacht Sales was very helpful and determine to find the right boat for me and my wife in 2020. They guided us through the purchase and are pleased with our boat. We recommend them as they either always answered the phone or promptly returned the call.',
      rating: 5,
    },

    {
      id: '3',
      name: 'Mack McKenzie',
      role: 'Verified Buyer',
      image: 'assets/images/about/reviews/chris.jpg',
      text: 'Great brokerage. Handled sale efficient and well communicated great. You want a good brokerage League City Yacht Sales is the place. 7 days a week they constantly worked on my deal to see that not only I received a good deal but so did the seller. Great service.',
      rating: 5,
    },
  ];
}
